import { apiFetch } from './apiClient';



export async function buscarConfigSistema() {
  return apiFetch('/configuracoes/sistema');
}

export async function salvarConfigSistema(dados) {
  return apiFetch('/configuracoes/sistema', {
    method: 'PATCH',
    body: JSON.stringify(dados),
  });
}

export async function buscarModelosClaude() {
  return apiFetch('/configuracoes/sistema/modelos');
}
